var map = {
	"./Dr.A.S.Periasamy Manikandan.jpeg": 60353,
	"./Dr.C.Gomadurai.jpeg": 65706,
	"./Dr.D.Nesakumar.jpg": 86924,
	"./Dr.G. Mugaishudeen.jpg": 68505,
	"./Dr.K.Kannan.jpg": 86669,
	"./Dr.M. Chiadambram.jpg": 37207,
	"./Dr.S.Mothil.jpg": 55599,
	"./Dr.V.Sangeetha.jpg": 92563,
	"./Mr.R. Sathish Raam.jpg": 94781,
	"./Mr.R.Ravi.jpg": 54590,
	"./Mr.S. Yuvaraj.jpg": 52469,
	"./Ms.J.JayaBharathi.jpeg": 21226,
	"./Ms.K.Kalaivani.jpg": 23266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82655;